import { GET_NOTARIZE_STATUS } from './action-types';

const notarizeData = {
  status: "",
  signer_info: {
    transaction_access_link: ""
  }
};

export default function reducer(state = notarizeData, action) {
  const { type, payload } = action;

  switch (type) {
    case `${GET_NOTARIZE_STATUS}_SUCCESS`:
      return {
        ...payload
      };

    default:
      return state;
  }
}
